export default function (axios) {
  return {
    postFormSubmit(data, params = {}) {
      return axios.post('/modules/form-submit', data, params)
    },
  }
}
